import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import CopyToClipboard from 'react-copy-to-clipboard';
import {default as Tooltip} from 'components/Tooltip';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {Request, RequestsMixin, GET} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import DocumentationMixin from '../mixins/DocumentationMixin';

const POPOVER_TIMEOUT = 2000;  // in ms

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.kitToken || ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const DocumentationSummaryController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    showShareResourceDoc: PropTypes.bool,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
  },

  mixins: [DocumentationMixin, RequestsMixin, ImmutableRenderMixin],

  getDefaultProps() {
    return {
      showShareResourceDoc: true,
    };
  },

  getInitialState() {
    return {
      usePane: 'use-automatically',
      embedCodeCopied: false,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      publications: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'publications'],
      }),
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({token: this.props.kitToken}),
      finishedPublications: rm.type(this.requests.publications, 'publications').all().filter(p => p.status === 'finished'),
    };
  },

  handleEmbedCodeCopied() {
    this.setState({embedCodeCopied: true}, () => {
      setTimeout(() => {
        this.setState({embedCodeCopied: false});
      }, POPOVER_TIMEOUT);
    });
  },

  handleTabClicked(event) {
    event.preventDefault();

    this.setState({usePane: event.currentTarget.rel});
  },

  renderAlert() {
    return (
      <div className="layout-center-center well bg-danger bg-img bg-img-icons p-xs-a-2x m-xs-b-lg text-xs-center" role="alert">
        <i className="ficon ficon-warning ficon-4x text-muted block m-xs-b-md"></i>
        <h3 className="text-2x m-xs-b-md">This documentation is incomplete <br />until you publish.</h3>
        <p className="lead text-muted m-xs-b-0">
          You&apos;ll be able to use your kit&apos;s assets and we'll show you exactly how to use them here once
          you <strong className="font-weight-semibold">publish your kit</strong>.
        </p>
      </div>
    );
  },

  renderAutomatically() {
    const {kit} = this.resources();
    const {embedCodeCopied} = this.state;
    const linkClasses = classnames({'is-disabled': kit.hasNeverBeenPublished}, {'text-gray-lighter': kit.hasNeverBeenPublished});
    const tabClass = (this.state.usePane === 'use-automatically') ? 'active' : 'hide';
    const embedCodeScriptTag = `<script src="https://${FORT_AWESOME_USE_URL}/${kit.token}.js"></script>`; // eslint-disable-line no-undef
    const embedCodeCopiedPopover = (embedCodeCopied) ? <Tooltip noIcon={true} content="Embed Code Copied!" /> : null;
    const directCssLink = (type) => `https://${FORT_AWESOME_USE_URL}/kits/${kit.token}/publications/latest/${type}.css`;

    return (
      <div role="tabpanel" className={tabClass} id="use-automatically">
        <p className="text-lg">
          The easiest way to use your kit - no need to manually update source files, maximum performance
          optimization, and use your kit with a single line of code.
        </p>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Publish Your Kit</h4>
            <p className="m-xs-b-">
              When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit's
              documentation and bust any caches (with extreme prejudice). If you've made a change you want to
              use, <strong className="font-weight-semibold">make sure you publish</strong>.
            </p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Reference Your Kit in Your Code</h4>
            <p className="m-xs-b-">
              After your kit has been published, <strong className="font-weight-semibold">copy and paste the kit's
              unique embed code into the HTML of your website</strong>. Make sure it goes near the top of
              your <code>&lt;head&gt;</code> tag.
            </p>
            <p className="text-muted text-small m-xs-b-sm">This Kit's Embed Code</p>

            <div className="gg gg-middle m-xs-b-lg">
              <div className="gg-col pre text-sm bg-gray-dark inset-darkest font-family-monospace p-xs-x-md p-xs-y-sm br-l">
                {embedCodeScriptTag}
              </div>
              <div className="gg-col min-width has-tooltip">
                {embedCodeCopiedPopover}
                <CopyToClipboard text={embedCodeScriptTag} onCopy={this.handleEmbedCodeCopied}>
                  <button className="copy-control btn btn-primary p-xs-x-md p-xs-y-sm br-r br-l-0" title="Copy"><i className="ficon ficon-copy"></i></button>
                </CopyToClipboard>
              </div>
            </div>

            <div className="alert alert-info bg-body has-icon m-xs-b-0">
              <i className="ficon ficon-info-circle ficon-lg alert-icon"></i>
              <p>
                If you're switching over to Fort Awesome from an existing icon font, don't forget to remove
                it from your website.
              </p>
              <p className="m-xs-b-0">
                If you're using Fort Awesome alongside an existing icon font (like Font Awesome), remember to use a different CSS prefix.
              </p>
              <p className="m-xs-b-0">
                If you'd like to use the CSS directly you can reference the <a href={directCssLink('woff')}>WOFF CSS</a>, <a href={directCssLink('woff2')}>WOFF2 CSS</a>, or <a href={directCssLink('eot')}>EOT CSS</a>.
              </p>
            </div>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Call icons and typefaces in your UI</h4>
            <p className="m-xs-b-">
              You'll then be able to call your icons and typefaces as you've set them up. Learn how to use
              your <Link to={`/kits/${kit.token}/docs/icons`} className={linkClasses}>icons</Link> and
              <Link to={`/kits/${kit.token}/docs/typefaces`} className={linkClasses}> typefaces</Link>.
            </p>
          </div>
        </div>

        <div className="alert alert-primary bg-body m-xs-b-0">
          <p className="m-xs-b-0">Still need help getting started? Check out <a target="_blank" href="https://articles.fortawesome.com/how-to-using-fort-awesome-icons-f50ab11a2d2a">our how-to article on using icons</a>.</p>
        </div>
      </div>
    );
  },

  renderManually() {
    const tabClass = (this.state.usePane === 'use-manually') ? 'active' : 'hide';

    return (
      <div role="tabpanel" className={tabClass} id="use-manually">
        <p className="text-lg">
          Want to place your files just so and serve them up your way and in your existing workflows? We completely
          get that. You can do so while still getting Fort Awesome's variety, customization, and bulletproof rendering.
        </p>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Publish Your Kit</h4>
            <p className="m-xs-b-">
              When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit's
              documentation and bust any caches (with extreme prejudice). If you've made a change you want to use,
              <strong className="font-weight-semibold">make sure you publish</strong>.
            </p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Download Your Kit</h4>
            <p className="m-xs-b-">
              After your kit has been published, you'll want to <strong className="font-weight-semibold">download a
              fresh copy of your kit's contents</strong> and move them alongside your project's files.
            </p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Call icons and typefaces in your UI</h4>
            <p className="m-xs-b-">
              Directly in your code, you'll then be able to call your icons and typefaces as you've set them up.
              <strong className="font-weight-semibold">Each kit comes with detailed documentation on how to reference
              every asset you've added</strong>. Be sure to read and share it with your team.
            </p>
          </div>
        </div>

        <div className="alert alert-primary bg-body m-xs-b-0">
          <p className="m-xs-b-0">Still need help getting started? Check out <a target="_blank" href="https://articles.fortawesome.com/how-to-serve-fort-awesome-assets-yourself-5419b88ee2d4">our how-to article on serving your kit's assets yourself</a>.</p>
        </div>
      </div>
    );
  },

  renderDesktop() {
    const tabClass = (this.state.usePane === 'use-desktop') ? 'active' : 'hide';

    return (
      <div role="tabpanel" className={tabClass} id="use-desktop">
        <p className="text-lg">
          Looking to use your kit's icons in design-based desktop apps? You can them both as a icon-font (a la how you
          would use Font Awesome's cheatsheet) or leverage the raw SVG versions of each.
        </p>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-1 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Publish Your Kit</h4>
            <p className="m-xs-b-">
              When you publish, Fort Awesome packages up and optimizes all of your assets. We also refresh your kit's
              documentation. If you've made a change you want to use, <strong className="font-weight-semibold">make
              sure you publish</strong>.
            </p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-2 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Download Your Kit</h4>
            <p className="m-xs-b-">After your kit has been published, you'll want to <strong className="font-weight-semibold">download a fresh copy of your kit's contents</strong> locally.</p>
          </div>
        </div>
        <div className="gg gg-top m-xs-b-lg">
          <div className="gg-col min-width"><i className="text-gray-lighter ficon ficon-circle-3 ficon-2x m-xs-r-md"></i></div>
          <div className="gg-col">
            <h4 className="m-xs-t-0 m-xs-b-xs text-lg">Use Icon Fonts or SVGs</h4>
            <p className="m-xs-b-0">
              Find the <code>*.otf</code> files in your downloaded kit, set it as the font in your current desktop
              application, and copy and paste the icons (not the unicode) directly from your kit's documentation into
              your designs. Conversely, you can also open any of the individual <code>*.svg</code> files for
              deeper manipulation.
            </p>
          </div>
        </div>

        <div className="alert alert-primary bg-body m-xs-b-0">
          <p className="m-xs-b-0">Still need help getting started? Check out <a target="_blank" href="https://articles.fortawesome.com/how-to-fort-awesome-assets-on-the-desktop-e3fd15df6f43">our how-to article on use your kit's assets on the desktop</a>.</p>
        </div>
      </div>
    );
  },

  renderMain() {
    const {kit, finishedPublications} = this.resources();
    const useAutomaticallyClass = classnames('nav-item', {active: this.state.usePane === 'use-automatically'});
    const useManuallyClass = classnames('nav-item', {active: this.state.usePane === 'use-manually'});
    const useDesktopClass = classnames('nav-item', {active: this.state.usePane === 'use-desktop'});
    const alertHtml = (finishedPublications.isEmpty()) ? this.renderAlert() : '';

    return (
      <div>
        <div className="row">
          <div className="col-xs-3 col-xs-push-9 p-xs-l-xl">
            {this.renderNavigation(kit, {hasBeenPublished: !finishedPublications.isEmpty()})}
          </div>
          <div className="col-xs-9 col-xs-pull-3">
            {alertHtml}
            <section className="get-started-build m-xs-b-xl" id="get-started-build">
              <h2 className="text-2x m-xs-b-0">Build your Kit</h2>
              <hr className="hr-lg m-xs-y-sm" />
              <p>
                If you haven&apos;t already, you&apos;ll want to add icons and typefaces for your site to use. Fort Awesome will
                take it from there when it comes to performance, and ease of use. Not sure where to start? Here are a few
                pointers:
              </p>
              <div className="alert alert-primary bg-body has-icon">
                <i className="ficon ficon-star ficon-lg alert-icon"></i>
                <h3 className="text-base">Add Icons</h3>
                <p className="m-xs-b-0">
                  Take advantage of <a href="/sets/starter">our starter icon library</a>, other <a href="/sets/premium">premium icon sets</a>,
                  or <Link to={`/kits/${kit.token}/icons/upload`}>upload your own icons</Link> to round out the perfect look and set for your site.
                </p>
              </div>
              <div className="alert alert-primary bg-body has-icon m-xs-b-xl">
                <i className="ficon ficon-font ficon-lg alert-icon"></i>
                <h3 className="text-base">Add Typefaces</h3>
                <p className="m-xs-b-0">
                  Have Fort Awesome manage and render your site&apos;s typefaces too. <Link to={`/kits/${kit.token}/typefaces/new`}>Choose from our included
                  typefaces</Link> or <Link to={`/kits/${kit.token}/typefaces/upload`}>upload your own</Link>.
                </p>
              </div>
            </section>
            <section className="get-started-use m-xs-b-xl" id="get-started-use">
              <h2 className="text-2x m-xs-b-0">How to use your Kit</h2>
              <hr className="hr-lg m-xs-y-sm" />
              <p className="m-xs-b-">
                Once you've added some icons, typefaces, and settings, you've got a few options for easily
                using your kit in your project.
              </p>
              <ul className="nav nav-tabs-inline m-xs-b-lg" role="tablist">
                <li className={useAutomaticallyClass}>
                  <a className="nav-link" href="#" rel="use-automatically" role="tab" onClick={this.handleTabClicked}>
                    Automatically served by Fort Awesome
                  </a>
                </li>
                <li className={useManuallyClass}>
                  <a className="nav-link" href="#" rel="use-manually" role="tab" onClick={this.handleTabClicked}>
                    Manually served by you
                  </a>
                </li>
                <li className={useDesktopClass}>
                  <a className="nav-link" href="#" rel="use-desktop" role="tab" onClick={this.handleTabClicked}>
                    Desktop app use
                  </a>
                </li>
              </ul>
              <div className="tab-content p-xs-l-lg p-xs-r-lg">
                {this.renderAutomatically()}
                {this.renderManually()}
                {this.renderDesktop()}
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-documentation-summary m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(DocumentationSummaryController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/DocumentationSummaryController.js